module.exports = __webpack_public_path__ + "static/media/pluralsight.d2e190d1.svg";